import React from "react";
import Sparkline from "./Sparkline";
import { formatValue, arrowFor } from "../labels";

const STATUS_COLOR = {
  good: "#2fd575",
  bad: "#ff5c5c",
  no_data: "#8b9bb4",
};

const IndicatorCard = ({ item, reportKey, lang, L }) => {
  const name = lang === "kz" ? item.name_kz : item.name_ru;
  const unit = lang === "kz" ? item.unit_kz : item.unit_ru;

  const status = item.status;
  const color = STATUS_COLOR[status];
  const noData = status === "no_data";

  const arrow = arrowFor(item.fact, item.plan);
  const dirHint = item.direction === "low" ? L.lowerBetter : L.higherBetter;

  const badgeText = noData ? L.noData : status === "good" ? L.done : L.notDone;

  return (
    <div className={`hc-card hc-card--${status}`}>
      <div className="hc-card__chart">
        <Sparkline
          series={item.series}
          statusColor={color}
          reportKey={reportKey}
          lang={lang}
          L={L}
          id={item.code}
        />
      </div>

      <div className="hc-card__info">
        <div className="hc-card__name">{name}</div>

        <div className="hc-card__value-row" style={{ color }}>
          {arrow && <span className="hc-card__arrow">{arrow}</span>}
          <span className="hc-card__value">{formatValue(item.fact)}</span>
          <span className="hc-card__unit">{unit}</span>
        </div>

        <div className="hc-card__meta">
          <span className={`hc-badge hc-badge--${status}`}>{badgeText}</span>
          <span className="hc-card__plan">
            {L.plan}: {formatValue(item.plan)}
            {!noData && <> · {dirHint}</>}
          </span>
        </div>
      </div>
    </div>
  );
};

export default IndicatorCard;
